import React, { useState, useEffect } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import './styles/App.css';
import M_Footer from './M_Footer';
import { Link } from 'react-router-dom';
import TopTitle from './TopTitle';
import queryString from 'query-string';
import axios from 'axios';
import { comma,instance } from './common';
import trash_img from './img/trash.png';
import check_on from './img/check_on.png';
import { formatDate } from './common';
import Bottom_menu from './Bottom_menu';


function totalPrice(data) {
  let price = 0;
  data.forEach(function (v) {
    if(v.is_check == 1){
      price += Number(v.daeri_price) * v.pr_count;
    }
  });
  return comma(price);
}

function MakeBtn({ query, history, data }) {

  const session = JSON.parse(window.sessionStorage.result);
  const { u_type, u_id } = session;

  let str = '';
  if (query.r_id) {
    str = '작업하기';
  } else {
    str = '지금 결제하기';

  }
  let obj = { u_id: u_id }
  const [cartData, setCartData] = useState([]);
  const [value, onChange] = useState(new Date());

  const GoPage = () => {
    if (query.r_id) {
      const fetchData = async () => {
        instance.post('/cart/checked', obj).then(function (res) {
          setCartData(res.data.rows);
          let obj2 = {
            s_id : JSON.stringify(res.data.rows)
          }
          let updateObj = {
            obj: obj2,
            whereField: 'r_id',
            whereValue: query.r_id,
          }          
          instance.post('/reserve/update', updateObj).then(function (res) {                   
              history.push('/Si_reserve_detail?r_id=' + query.r_id+'&date='+formatDate(value));
          });               
        });
      };
      fetchData();
    

      
    } else {
      if(data.length !== 0){
        history.push('/order-sheet');
      }else{
          alert('결제할 상품이 존재하지 않습니다.');
      }
      
    }
  }
  return (
    <span className="btn btn-primary r_btnsize" onClick={GoPage}>{str}</span>
  )
}

function P_cart({ history, location, match }) {

  let session = JSON.parse(window.sessionStorage.result);
  let { u_type, u_id } = session;
  const query = queryString.parse(location.search);

  const [data, setData] = useState([]);


  let obj = {
    u_id: u_id,
  }

  useEffect(() => {

    const fetchData = async () => {
      instance.post('/p_cart/id', obj).then(function (res) {

        setData(res.data.rows);

      });

    };

    fetchData();

  }, []);

  const wordBreak = {
    wordBreak: 'keep-all'
  }
  const w60 = {
    width: '60%',
    verticalAlign: 'top'
  }
  const w30 = {
    width: '40%'
  }

  const moreCss = {
    width: '35px'
  }


  const bgSet = {
    backgroundPosition: 'center',
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    width: '25%',
    height: '80px',
    borderRadius: '5px',
    display: 'inline-block',
  }

  const ab = {
    position: 'absolute',
    right: '-4px',
    top: '14px',
    color: 'lightgray',
    fontSize: '10px'
  }
  const traswi = {
    width: '25px'
  }


  const deleteCart = (e) => {
    const { id } = e.target.dataset;

    setData(data.filter(v => v.p_cart_id != id));

    let obj = { p_cart_id: id };

    const fetchData = async () => {
      instance.post('/p_cart/delete', obj).then(function (res) {
        alert('해당 상품이 삭제되었습니다.');

      });

    };

    fetchData();


  }

  const checkedData = (e) => {
    const {cart_id,is_check} = e.target.dataset;
    let reversed;
    if(is_check == 1){
      reversed = 0;
    }else if(is_check == 0){
      reversed = 1;
    }
    setData(data.map(v => v.p_cart_id == cart_id ? {...v,is_check:reversed} : v))
    let obj = {
      is_check:reversed
    }
    let UpdateObj = {
      obj:obj,
      whereField:'p_cart_id',
      whereValue:cart_id
    }
    const fetchData = async () => {

      instance.post('/p_cart/update', UpdateObj).then(function (res) {
        
        
      });

    };

    fetchData();
  }
  

  const allChecked = () => {
    setData(data.map(v => ({...v,is_check:1}) ))
    let obj = {
      is_check:1
    }
    let UpdateObj = {
      obj:obj,
      whereField:'u_id',
      whereValue:u_id
    }
    const fetchData = async () => {

      instance.post('/p_cart/update', UpdateObj).then(function (res) {
        
        
      });

    };

    fetchData();
  }

  const allDelete = () => {
    setData(data.filter(v => v.u_id != u_id));
  
      let obj = { u_id: u_id };
  
      const fetchData = async () => {
        instance.post('/p_cart/all-delete', obj).then(function (res) {
          alert('전체 삭제 되었습니다.');
  
        });
  
      };
  
      fetchData();
  }

  console.log('product cart data : ', data)

  return (
    <>
      <Container className="mb-5" style={{paddingBottom:'100px'}}>
        <div className="c_pad">
          <TopTitle title="장바구니" />
          <div className="row p-0">
            <div className="col-6 p-0">
              <span style={{ position: 'relative',left: '-7px',cursor:'pointer' }} onClick={allChecked}><img src={check_on} style={{width:'17px',verticalAlign:'text-bottom'}}/>전체선택</span>
            </div>
            <div className="col-6 p-0 text-right">
            <span style={{cursor:'pointer',color:'#787878' }} onClick={allDelete}>전체삭제</span>
            </div>
          </div>
          <div className="row p-0">
            {
              data.map(v => <div className="col-12 pt-4 pb-3" key={v.s_id} data-id={v.s_id} style={{ position: 'relative' }}>
                {
                  v.is_check == 1
                  ? <input type="checkbox" style={{ position: 'absolute', top: '11px', left: '-5px' }} data-cart_id={v.p_cart_id} data-is_check={v.is_check} onClick={checkedData} checked/>
                  : <input type="checkbox" style={{ position: 'absolute', top: '11px', left: '-5px' }} data-cart_id={v.p_cart_id} data-is_check={v.is_check} onClick={checkedData} />
                }
               
                <div className="" data-id={v.pr_id}>
                  <div data-id={v.pr_id} style={{ ...bgSet, backgroundImage: 'url(\'' + v.pr_img + '\')' }}></div><div data-id={v.pr_id} className="w-75 d-inline-block" style={{ ...wordBreak, verticalAlign: 'top' }}>
                    <h4 className="text-primary font-weight-bold ml-3" data-id={v.pr_id} style={{ width: '160px' }}>{v.pr_name}</h4>
                    <div data-id={v.pr_id} style={{ marginTop: '15px' }}>
                      <h4 data-id={v.pr_id} className="font-weight-bold ml-3"> 수량 : {v.pr_count} 개</h4>
                      <h4 data-id={v.pr_id} className="font-weight-bold ml-3 text-primary">{comma(v.daeri_price * v.pr_count)} 원</h4>
                    </div>
                  </div>
                  <span data-id={v.p_cart_id} style={ab} onClick={deleteCart}><img data-id={v.p_cart_id} src={trash_img} style={traswi} /></span>
                </div>
              </div>)
            }

          </div>
          <div className="row mb-4 p-0" style={{ borderBottom: '2px solid black' }}>
            <h3 className="font-weight-bold mb-3">금액정보</h3>
          </div>
          <div className="row p-0">
            <div className="col-4 pl-0">
              <span className="font-weight-bold d-block r_s_size">상품 총액</span>
            </div>
            <div className="col-8">
              <div className="mb-3 text-right">
                <span className="font-weight-bold" id="service_price">
                  {totalPrice(data)}원
                            </span>
              </div>
            </div>
          </div>
          <hr className="r_mg_top_none" />
          <div className="row r_mbdown p-0">
            <div className="col-3 pl-0">
              <span className="font-weight-bold d-block r_s_size r_nowrap">총 결제 금액</span>
            </div>
            <div className="col-9">
              <div className="r_r_color font-weight-bold text-right r_s_size" id="totalPrice">{totalPrice(data)}원</div>
            </div>

          </div>
          <div className="row mb-2 p-0 mt-5">
            <div className="col-6 pl-0">
              <span className="btn btn-outline-secondary r_btnsize" onClick={() => history.goBack()}>취소</span>
            </div>
            <div className="col-6 pr-0">
              <MakeBtn query={query} history={history} data={data} />
            </div>
          </div>
          
        </div>
        
      </Container>
      
      <Bottom_menu />

    </>

  );
}

export default P_cart;
